import React, { useContext } from 'react';

import * as S from './styles';
import { DataFormProps } from 'types/InputsGridOfBannersProps';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import TypeStoreContext from 'context/TypeStoreContext';
import Default from './interfaces/Default';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
// import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface GridOfBannersProps {
	item: ItemDynamicPageInPhone;
}

export default function GridOfBanners({ item }: GridOfBannersProps) {
	const { data } = item;
	const { typeStore } = useContext(TypeStoreContext);

	const bannersData: DataFormProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <Default bannersData={bannersData} />;

			case 'grocery':
				return <Default bannersData={bannersData} />;

			case 'fashion':
				return <Default bannersData={bannersData} />;

			default:
				return <Default bannersData={bannersData} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(bannersData.schedule_start !== '' ||
				bannersData.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={bannersData.countdown}
					endDate={bannersData.schedule_end}
					startDate={bannersData.schedule_start}
				/>
			)}

			{returnInterfaceByTypeStore()}
		</S.container>
	);
}
